import { pluck } from 'ramda'
import { createSelector } from 'reselect'

export const getExamReviews = state => state.entities.reviews
export const getExamReviewsShare = createSelector([getExamReviews], reviews =>
  pluck('share', reviews),
)
